export default __webpack_public_path__ + "static/media/Terms-And-Condition.262c1b66.jpg";